// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tn1L","colMin":"styles_colMin__1MMPo"};